/* eslint-disable import/no-anonymous-default-export */
import { RawRuleOf } from "@casl/ability";
import { AppAbility } from "../shared/CASL/appAbility";
import { IFeature, IRuolo, IUser } from "../shared/interfaces";
import usersService from "./users.service";

const getRawRuleForAdministratorContext = (currentUser: IUser, allRoles: IRuolo[], aooId: number): RawRuleOf<AppAbility>[] => {
    let rawRules: RawRuleOf<AppAbility>[] = [];
    if (currentUser && currentUser.ruoliUorContext && allRoles) {



        /// verifico se l'utente è Supervisore o Admin
        let isSupervisor = usersService.userIsSupervisore(currentUser!, aooId);
        let supervisorRole = allRoles?.find(el => el.nome === "Supervisore");

        let isAdmin = usersService.userIsAdmin(currentUser!, aooId);;
        let adminRole = allRoles?.find(el => el.nome === "Admin");

        let superAdminRole = allRoles?.find(el => el.nome === "SuperAdmin");


        if (isAdmin && adminRole) {
            rawRules = adminRole.permissions;
        }
        else if (isSupervisor && supervisorRole) {
            rawRules = supervisorRole.permissions;
        }

        if (currentUser.isSuperAdmin && superAdminRole) {
            rawRules = remapRulesForSuperAdmin(superAdminRole, rawRules);
        }
        // se rulesFromUserRoles è vuoto significa che l'utente non ha un ruolo e quindi non può accedere a nulla
    }


    return rawRules;
}

const remapRulesForSuperAdmin = (superAdminRole, rawRules: RawRuleOf<AppAbility>[]): RawRuleOf<AppAbility>[] => {
    let newRawRules: RawRuleOf<AppAbility>[] = [...rawRules];
    var superAdminPermissions = [...superAdminRole.permissions];
    superAdminPermissions.forEach((rule, index) => {
        if (rule.action.toString() === 'manage') {
            /// rimuovo i permessi che per l'utente superadmin hanno action 'manage'
            newRawRules = newRawRules.filter(el => el.subject !== rule.subject);
        }

        newRawRules.push(rule);
    });
    return newRawRules;

}

const getRulesFromFeatures = (features: IFeature[]) => {
    let rawRules: RawRuleOf<AppAbility>[] = [];

    if (features) {

        let enabledFeatureKeys: string[] = features!.filter(el => el.enabled).reduce((a: string[], o) => (o.key && a.push(o.key), a), [])


        if (enabledFeatureKeys && enabledFeatureKeys.length > 0) {
            rawRules.push({
                action: "use",
                subject: "IFeature",
                conditions: {
                    "key": {
                        "$in": enabledFeatureKeys
                    }
                }
            });
        };
    }
    return rawRules;
}
export default { getRawRuleForAdministratorContext, getRulesFromFeatures }